import { getRoundedBalanceInFiat, formatWithCommas } from './helpers';

type BalanceDisplayProps = {
  amount: string;
  showAlmostEqualSignUSD?: boolean;
  showSignUSD?: boolean;
  nearTokenFiatValueUSD?: string | undefined;
  showSymbolUSD?: boolean;
  isNear?: boolean;
  decimals?: number;
};

const BalanceDisplay = ({
  amount,
  showAlmostEqualSignUSD = true,
  showSignUSD = true,
  showSymbolUSD = true,
  nearTokenFiatValueUSD,
  isNear = true,
  decimals
}: BalanceDisplayProps) => {
  const roundedBalanceInUSD =
    amount &&
    nearTokenFiatValueUSD &&
    getRoundedBalanceInFiat(amount, nearTokenFiatValueUSD, isNear, decimals);

  const USDSymbol = 'USD';
  const roundedBalanceInUSDIsBelowThreshold = roundedBalanceInUSD === '< $0.01';

  if (roundedBalanceInUSD) {
    return (
      <>
        {!roundedBalanceInUSDIsBelowThreshold && (
          <>
            {showAlmostEqualSignUSD && '≈ '}
            {showSignUSD && <>$</>}
          </>
        )}

        {formatWithCommas(roundedBalanceInUSD)}
        {showSymbolUSD && ` ${USDSymbol}`}
      </>
    );
  } else if (roundedBalanceInUSD?.length === 0) {
    return <>{showSignUSD && <>$</>}0</>;
  } else {
    return <>— {USDSymbol}</>;
  }
};

export default BalanceDisplay;
